import "react";
import { Tooltip } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Geo/LatLngMapLink.tsx
function LatLngMapLink({ lat, lng }) {
	if (!lat || !lng) return null;
	return /* @__PURE__ */ jsx(Tooltip, {
		tooltip: /* @__PURE__ */ jsxs("span", { children: [
			lat,
			" / ",
			lng,
			" ",
			/* @__PURE__ */ jsx("a", {
				target: "_blank",
				href: `https://www.google.com/maps/?q=${lat},${lng}`,
				rel: "noreferrer",
				children: "map"
			})
		] }),
		children: "geo-coords"
	});
}
//#endregion
export { LatLngMapLink };

//# sourceMappingURL=LatLngMapLink.js.map